import { sdk } from "@lib/config"

export type ContactEnquiryPayload = {
  name: string
  email: string
  phone?: string
  subject?: string
  message: string
  // Honeypot — must stay empty; the backend silently drops submissions that
  // fill it.
  website?: string
}

// Submits the contact form to the backend, which emails sales@ via SendGrid.
// Awaited (unlike datasheet capture) so the form can show success/failure.
export async function submitContactEnquiry(
  payload: ContactEnquiryPayload
): Promise<void> {
  await sdk.client.fetch("/store/contact-enquiries", {
    method: "POST",
    body: payload,
  })
}
